import { UnsupportedSamplesLanguages } from 'types/enums';

export const getIsUnsupportedLocale = (
    locale: UnsupportedSamplesLanguages | string | undefined,
): locale is UnsupportedSamplesLanguages => {
    return (
        !!locale &&
        Object.values<string>(UnsupportedSamplesLanguages).includes(locale)
    );
};
